import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4af9cff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title text-muted" }
const _hoisted_2 = { class: "summary" }
const _hoisted_3 = { class: "results bg-light" }
const _hoisted_4 = { class: "status-icon" }
const _hoisted_5 = {
  key: 0,
  class: "bi bi-circle"
}
const _hoisted_6 = {
  key: 1,
  class: "bi bi-check-circle-fill text-success"
}
const _hoisted_7 = {
  key: 2,
  class: "bi bi-x-circle-fill text-danger"
}
const _hoisted_8 = { class: "rid" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "elapsed-time text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(" Results "),
      _createElementVNode("span", _hoisted_2, _toDisplayString([..._ctx.results.values()].filter((x) => x !== undefined).length) + "/" + _toDisplayString(_ctx.results.size), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "",
          key: index
        }, [
          _createElementVNode("span", _hoisted_4, [
            (item[1] === undefined)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : _createCommentVNode("", true),
            (item[1] === true)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6))
              : _createCommentVNode("", true),
            (item[1] === false)
              ? (_openBlock(), _createElementBlock("i", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_8, "RPID: " + _toDisplayString(item[0]), 1),
          _createVNode(_component_router_link, {
            class: "rid-link",
            to: {
          name: 'RestaurantConfigurations',
          params: { restaurantId: item[0] },
        },
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    (_ctx.elapsedTime && _ctx.elapsedTime !== '')
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Completed in " + _toDisplayString(_ctx.elapsedTime), 1))
      : _createCommentVNode("", true)
  ], 64))
}